import styles from "./Portfolio.module.css";
import projects from "../../data";
import { Link } from "react-router-dom";
function Portfolio() {
  // const maxWords = 13;
  function truncateText(text, maxWords) {
    const words = text.split(" ");
    const excerpt = words.slice(0, maxWords).join(" ");

    // Add ellipsis (...) if the excerpt is shorter than the original text
    if (words.length > maxWords) {
      return excerpt + "...";
    } else {
      return excerpt;
    }
  }

  return (
    <section className={styles.section} id="portfolio">
      <p className={styles.smallP}>Portfolio</p>
      <h3>
        <strong>Projects I Have Worked On</strong>
      </h3>

      <div className={styles.cardContainer}>
        {projects.slice(0, 6).map(project => (
          <div key={project.id} className={styles.card}>
            <div className="imgContainer">
              <img
                src={process.env.PUBLIC_URL + project.img}
                loading="lazy"
                alt="img"
              />
            </div>
            <h6>{project.title}</h6>
            <p>
              {truncateText(project.desc, 16)}
              <Link to={`/project/${project.id}`}>
                <span> Read More &rsaquo; </span>
              </Link>
            </p>
            <div className={styles.linksContainer}>
              <a href={project.link} className={styles.cardFirstChild}>
                View Project
              </a>
              {project.sourceCode ? (
                <a
                  href={project.sourceLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.cardSecondChild}
                >
                  Source Code
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>
      <Link to="/projects" className={styles.intouch}>
        View more projects
      </Link>
    </section>
  );
}

export default Portfolio;
